import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import BookingConfirmation from "@/pages/BookingConfirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import FAQPage from "@/pages/FAQPage";
import ReviewsPage from "@/pages/ReviewsPage";
import AboutPage from "@/pages/AboutPage";
import GalleryPage from "@/pages/GalleryPage";
import GuestLogin from "@/pages/GuestLogin";
import GuestPortal from "@/pages/GuestPortal";
import BeachesPage from "@/pages/BeachesPage";
import GettingHerePage from "@/pages/GettingHerePage";
import ThingsToDoPage from "@/pages/ThingsToDoPage";
import WinterRetreatsPage from "@/pages/WinterRetreatsPage";
import RentalAgreementPage from "@/pages/RentalAgreementPage";
import PayRequestPage from "@/pages/PayRequestPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/booking/confirmation" element={<BookingConfirmation />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/guest-login" element={<GuestLogin />} />
            <Route path="/guest-portal" element={<GuestPortal />} />
            <Route path="/beaches" element={<BeachesPage />} />
            <Route path="/getting-here" element={<GettingHerePage />} />
            <Route path="/things-to-do" element={<ThingsToDoPage />} />
            <Route path="/winter-retreats" element={<WinterRetreatsPage />} />
            <Route path="/rental-agreement" element={<RentalAgreementPage />} />
            <Route path="/pay/:type/:id" element={<PayRequestPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
// Build timestamp: 1768613449
